import {Component} from "react";
import {Link} from "react-router-dom";

class BankfeeRow extends Component{
    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    render() {
        const {index,item} = this.props;
        return(
            <tr>
                <td>{index+1}</td>
                <td>
                    {item?.bankCode === 'VCB'?'Vietcombank':''}
                    {item?.bankCode === 'AGB'?'Agribank':''}
                    {item?.bankCode === 'HDB'?'HDBank':''}
                </td>
                <td>{item?.code}</td>
                <td>{item?.name}</td>
                <td>{item?.paymentMonth}</td>
                <td>{item?.status === '1'?'Đang xử lý':item?.status === '2'?'Đã xử lý xong có điều chỉnh':item?.status === '3'?'Đã xử lý xong không điều chỉnh':'Chưa xử lý'}</td>
                <td>{
                    item?.isConfirmed === 'Y' ?
                    <span className={'badge badge-pill badge-light'}>Đã xác nhận</span>
                    : <span className={'badge badge-pill badge-warning'}>Chưa xác nhận</span>
                }
                </td>
                <td><Link to={'/bp/bankfee/detail/'+item.id} className={'badge badge-info even-larger-badge'}>Xem chi tiết</Link></td>
            </tr>
        )
    }
}
export default BankfeeRow